import _get from "lodash/get";
import { getCheckout, State as CheckoutState } from "./checkout";
import { CHECKOUT_LABELS_NOSUBSCRIPTIONS, CHECKOUT_LINKS_B2B, MaybeEmpty } from "../../../../../constants";
import { StepIndicatorType } from "../../../../../models";
import { BrregResult, BusinessDetails, BusinessDetailsDetails } from "../../../../../models/state";

export type State = CheckoutState;

// details
export const getBusinessDetails = (state: State): MaybeEmpty<BusinessDetails> =>
    getCheckout(state).businessDetails || {};
export const getBrregNames = (state: State): BrregResult[] => getBusinessDetails(state).brregNameSearch || [];
export const shouldShowOrgOrNameInputField = (state: State): boolean =>
    !!getBusinessDetails(state).shouldShowOrgOrNameInputField;
export const shouldShowInputFields = (state: State): boolean => !!getBusinessDetails(state).shouldShowInputFields;
export const shouldShowPBFields = (state: State): boolean => !!getBusinessDetails(state).shouldShowPBFields;
export const getDetails = (state: State): MaybeEmpty<BusinessDetailsDetails> => getBusinessDetails(state).details || {};
export const getOrganizationName = (state: State): string => getDetails(state).businessName || "";
export const getOrganizationNumber = (state: State): string => getDetails(state).orgNumber || "";
export const getOrganizationCity = (state: State): string => getDetails(state).city || "";
export const getOrganizationPostcode = (state: State): string => getDetails(state).postcode || "";
export const getOrganizationFullCity = (state: State): string =>
    `${_get(getDetails(state), "postcode", "")} ${_get(getDetails(state), "city", "")}`.trim();
export const getOrganizationAddress = (state: State): string => getDetails(state).street || "";
export const getContactEmail = (state: State): string => getDetails(state).email || "";
export const getContactPhone = (state: State): string => getDetails(state).phone || "";
export const getContactFullName = (state: State): string =>
    `${_get(getDetails(state), "firstName", "")} ${_get(getDetails(state), "lastName", "")}`.trim();
export const successfullySetBusinessDetails = (state: State): boolean =>
    !!getBusinessDetails(state).setBusinessDetailsSuccess;

// meta
export const getStepIndicatorData = (): StepIndicatorType => {
    return {
        hide: false,
        steps: 3,
        labels: CHECKOUT_LABELS_NOSUBSCRIPTIONS,
        links: CHECKOUT_LINKS_B2B,
    };
};
